var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { AmwalCheckoutButton } from 'amwal-checkout-button-react';
var AmwalMagentoReactButton = function (_a) {
    var triggerContext = _a.triggerContext, locale = _a.locale, scopeCode = _a.scopeCode, productId = _a.productId, buttonId = _a.buttonId, preCheckoutTask = _a.preCheckoutTask, onSuccessTask = _a.onSuccessTask, onCancelTask = _a.onCancelTask, _b = _a.emptyCartOnCancellation, emptyCartOnCancellation = _b === void 0 ? triggerContext === 'product-listing-page' || triggerContext === 'product-detail-page' || triggerContext === 'product-list-widget' || triggerContext === 'amwal-widget' : _b, _c = _a.baseUrl, baseUrl = _c === void 0 ? scopeCode ? "/rest/".concat(scopeCode, "/V1") : '/rest/V1' : _c, extraHeaders = _a.extraHeaders, overrideCartId = _a.overrideCartId, _d = _a.redirectURL, redirectURL = _d === void 0 ? '/checkout/onepage/success' : _d, _e = _a.performSuccessRedirection, performSuccessRedirection = _e === void 0 ? function () { window.location.href = redirectURL; } : _e, debug = _a.debug;
    var buttonRef = React.useRef(null);
    var _f = React.useState(undefined), config = _f[0], setConfig = _f[1];
    var _g = React.useState(0), amount = _g[0], setAmount = _g[1];
    var _h = React.useState(0), taxes = _h[0], setTaxes = _h[1];
    var _j = React.useState(0), discount = _j[0], setDiscount = _j[1];
    var _k = React.useState(0), fees = _k[0], setFees = _k[1];
    var _l = React.useState(''), feesDescription = _l[0], setFeesDescription = _l[1];
    var _m = React.useState(undefined), cartId = _m[0], setCartId = _m[1];
    var _o = React.useState([]), shippingMethods = _o[0], setShippingMethods = _o[1];
    var _p = React.useState(undefined), placedOrderId = _p[0], setPlacedOrderId = _p[1];
    var _q = React.useState(false), finishedUpdatingOrder = _q[0], setFinishedUpdatingOrder = _q[1];
    var _r = React.useState(false), receivedSuccess = _r[0], setReceivedSuccess = _r[1];
    var _s = React.useState(undefined), refIdData = _s[0], setRefIdData = _s[1];
    var _t = React.useState(false), triggerPreCheckoutAck = _t[0], setTriggerPreCheckoutAck = _t[1];
    var applyButtonConfig = function (data) {
        var _a, _b, _c;
        setConfig(data);
        setAmount(data.amount);
        setDiscount((_a = data.discount) !== null && _a !== void 0 ? _a : 0);
        setTaxes((_b = data.tax) !== null && _b !== void 0 ? _b : 0);
        setFees((_c = data.fees) !== null && _c !== void 0 ? _c : 0);
        if (data.cart_id)
            setCartId(data.cart_id);
    };
    React.useEffect(function () {
        var initalRefIdData = {
            identifier: '100',
            customer_id: '0',
            timestamp: Date.now()
        };
        setRefIdData(initalRefIdData);
        fetch("".concat(baseUrl, "/amwal/button/cart"), {
            method: 'POST',
            headers: __assign(__assign({}, extraHeaders), { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }),
            body: JSON.stringify({
                refIdData: initalRefIdData,
                triggerContext: triggerContext,
                cartId: overrideCartId !== null && overrideCartId !== void 0 ? overrideCartId : cartId,
                productId: productId,
                locale: locale
            })
        })
            .then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, response.json()];
                    case 1:
                        data = _a.sent();
                        if (!response.ok)
                            throw new Error(data);
                        return [2 /*return*/, data];
                }
            });
        }); })
            .then(function (data) { applyButtonConfig(data); })
            .catch(function (err) { console.error(err); });
    }, []);
    var getQuote = function (addressData) { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, quote, subtotal;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetch("".concat(baseUrl, "/amwal/get-quote"), {
                        method: 'POST',
                        headers: __assign(__assign({}, extraHeaders), { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }),
                        body: JSON.stringify({
                            ref_id: config === null || config === void 0 ? void 0 : config.ref_id,
                            address_data: addressData,
                            is_pre_checkout: false,
                            trigger_context: triggerContext,
                            ref_id_data: refIdData,
                            order_items: [],
                            cartId: overrideCartId !== null && overrideCartId !== void 0 ? overrideCartId : cartId,
                            productId: productId
                        })
                    })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _b.sent();
                    if (!response.ok)
                        throw new Error((_a = data.message) !== null && _a !== void 0 ? _a : response.statusText);
                    if (data instanceof Array && data.length > 0) {
                        quote = data[0];
                        setCartId(quote.cart_id);
                        subtotal = parseFloat(quote.amount) -
                            parseFloat(quote.tax_amount) -
                            parseFloat(quote.shipping_amount) +
                            parseFloat(quote.discount_amount);
                        setAmount(subtotal);
                        setTaxes(quote.tax_amount);
                        setDiscount(quote.discount_amount);
                        setFees(quote.additional_fee_amount);
                        setFeesDescription(quote.additional_fee_description);
                        setShippingMethods(Object.entries(quote.available_rates).map(function (_a) {
                            var id = _a[0], rate = _a[1];
                            return {
                                id: id,
                                label: rate.carrier_title,
                                price: rate.price
                            };
                        }));
                        return [2 /*return*/, quote];
                    }
                    throw new Error("Unexpected get-quote result ".concat(JSON.stringify(data)));
            }
        });
    }); };
    var handleAmwalAddressUpdate = function (event) {
        getQuote(event.detail)
            .catch(function (err) {
            var _a;
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent('amwalAddressTriggerError', {
                detail: {
                    description: err === null || err === void 0 ? void 0 : err.toString(),
                    error: err === null || err === void 0 ? void 0 : err.toString()
                }
            }));
            console.error(err);
        });
    };
    React.useEffect(function () {
        var _a;
        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new Event('amwalAddressAck'));
    }, [shippingMethods]);
    var completeOrder = function (amwalOrderId) {
        fetch("".concat(baseUrl, "/amwal/pay-order"), {
            method: 'POST',
            headers: __assign(__assign({}, extraHeaders), { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }),
            body: JSON.stringify({
                order_id: placedOrderId,
                amwal_order_id: amwalOrderId
            })
        })
            .then(function (response) {
            if (!response.ok)
                return;
            window.dispatchEvent(new CustomEvent('cartUpdateNeeded'));
            if (onSuccessTask) {
                onSuccessTask({ order_id: placedOrderId, amwal_transaction_id: amwalOrderId })
                    .catch(function (err) {
                    console.error(err);
                })
                    .finally(function () {
                    setFinishedUpdatingOrder(true);
                });
            }
            else {
                setFinishedUpdatingOrder(true);
            }
        })
            .catch(function (err) {
            console.error(err);
        });
    };
    var handleAmwalDismissed = function (event) {
        var _a;
        if (!event.detail.orderId)
            return;
        if (event.detail.paymentSuccessful) {
            if (placedOrderId) {
                completeOrder(event.detail.orderId);
            }
        }
        else if (onCancelTask) {
            onCancelTask()
                .catch(function (err) {
                console.error(err);
            });
        }
        else if (emptyCartOnCancellation) {
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.setAttribute('disabled', 'true');
            fetch("".concat(baseUrl, "/amwal/clean-quote"), {
                method: 'POST',
                headers: __assign(__assign({}, extraHeaders), { 'X-Requested-With': 'XMLHttpRequest' })
            }).finally(function () {
                var _a;
                (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.removeAttribute('disabled');
                window.dispatchEvent(new CustomEvent('cartUpdateNeeded'));
            });
        }
    };
    var handleUpdateOrderOnPaymentsuccess = function (event) {
        completeOrder(event.detail.orderId);
    };
    var handleAmwalCheckoutSuccess = function (_event) {
        setReceivedSuccess(true); // coordinate with the updateOrderOnPaymentsuccess event
    };
    React.useEffect(function () {
        var _a;
        if (finishedUpdatingOrder && receivedSuccess) {
            if (placedOrderId) {
                (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.dismissModal().finally(function () {
                    performSuccessRedirection(placedOrderId);
                });
            }
            else {
                console.error('Unexpected state. placedOrderId is undefined after finished updating order and receiving success');
            }
        }
    }, [finishedUpdatingOrder, receivedSuccess]);
    var asyncHandleAmwalPrePayTrigger = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var response, data;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, fetch("".concat(baseUrl, "/amwal/place-order"), {
                        method: 'POST',
                        headers: __assign(__assign({}, extraHeaders), { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }),
                        body: JSON.stringify({
                            ref_id: config === null || config === void 0 ? void 0 : config.ref_id,
                            address_data: event.detail,
                            cartId: overrideCartId !== null && overrideCartId !== void 0 ? overrideCartId : cartId,
                            amwal_order_id: event.detail.id,
                            ref_id_data: refIdData,
                            trigger_context: triggerContext,
                            has_amwal_address: !(triggerContext === 'regular-checkout')
                        })
                    })];
                case 1:
                    response = _d.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _d.sent();
                    if (response.ok) {
                        setPlacedOrderId(data.entity_id);
                        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent('amwalPrePayTriggerAck', {
                            detail: {
                                order_id: data.entity_id,
                                order_total_amount: data.total_due
                            }
                        }));
                    }
                    else {
                        (_b = buttonRef.current) === null || _b === void 0 ? void 0 : _b.dispatchEvent(new CustomEvent('amwalPrePayTriggerError', {
                            detail: {
                                description: (_c = data.message) !== null && _c !== void 0 ? _c : data
                            }
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleAmwalPrePayTrigger = function (event) {
        asyncHandleAmwalPrePayTrigger(event)
            .catch(function (err) {
            var _a;
            console.error(err);
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent('amwalPrePayTriggerError', {
                detail: {
                    description: err === null || err === void 0 ? void 0 : err.toString()
                }
            }));
        });
    };
    var handleAmwalPreCheckoutTrigger = function (_event) {
        var getConfig = function (preCheckoutCartId) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(baseUrl, "/amwal/button/cart"), {
                            method: 'POST',
                            headers: __assign(__assign({}, extraHeaders), { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }),
                            body: JSON.stringify({
                                refIdData: refIdData,
                                triggerContext: triggerContext,
                                locale: locale,
                                cartId: (_a = preCheckoutCartId !== null && preCheckoutCartId !== void 0 ? preCheckoutCartId : overrideCartId) !== null && _a !== void 0 ? _a : cartId
                            })
                        })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        }); };
        var preCheckoutPromise = (preCheckoutTask != null)
            ? preCheckoutTask().then(function (preCheckoutCartId) { return __awaiter(void 0, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getConfig(preCheckoutCartId)];
                        case 1:
                            response = _a.sent();
                            if (preCheckoutCartId) {
                                setCartId(preCheckoutCartId);
                            }
                            return [2 /*return*/, response];
                    }
                });
            }); })
            : getConfig();
        preCheckoutPromise
            .then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, response.json()];
                    case 1:
                        data = _a.sent();
                        if (!response.ok)
                            throw new Error(data);
                        return [2 /*return*/, data];
                }
            });
        }); })
            .then(function (data) {
            applyButtonConfig(data);
            setTriggerPreCheckoutAck(true);
        })
            .catch(function (err) {
            var _a;
            console.error(err);
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent('amwalPrePayTriggerError', {
                detail: {
                    description: err === null || err === void 0 ? void 0 : err.toString()
                }
            }));
        });
    };
    React.useEffect(function () {
        var _a, _b;
        if (triggerPreCheckoutAck) {
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent('amwalPreCheckoutTriggerAck', {
                detail: {
                    order_position: triggerContext,
                    plugin_version: 'Magento ' + ((_b = config === null || config === void 0 ? void 0 : config.plugin_version) !== null && _b !== void 0 ? _b : '')
                }
            }));
            setTriggerPreCheckoutAck(false);
        }
    }, [triggerPreCheckoutAck]);
    return (config != null)
        ? _jsx(AmwalCheckoutButton, { ref: buttonRef, id: buttonId, amount: amount, taxes: taxes, discount: discount, fees: fees, feesDescription: feesDescription, shippingMethods: shippingMethods, merchantId: config.merchant_id, countryCode: config.country_code, darkMode: config.dark_mode, emailRequired: config.email_required, addressRequired: config.address_required, refId: config.ref_id, label: config.label, showPaymentBrands: config.show_payment_brands, initialEmail: config.initial_email, initialPhoneNumber: config.initial_phone, initialAddress: config.initial_address, allowedAddressCities: config.allowed_address_cities, allowedAddressStates: config.allowed_address_states, allowedAddressCountries: JSON.stringify(config.allowed_address_countries), "test-environment": config.test_environment, addressHandshake: true, sendExtraAddressFields: true, onAmwalAddressUpdate: handleAmwalAddressUpdate, onAmwalDismissed: handleAmwalDismissed, onAmwalCheckoutSuccess: handleAmwalCheckoutSuccess, enablePrePayTrigger: config.enable_pre_pay_trigger, onAmwalPrePayTrigger: handleAmwalPrePayTrigger, enablePreCheckoutTrigger: config.enable_pre_checkout_trigger, onAmwalPreCheckoutTrigger: handleAmwalPreCheckoutTrigger, onUpdateOrderOnPaymentsuccess: handleUpdateOrderOnPaymentsuccess, postcodeOptionalCountries: JSON.stringify(config.post_code_optional_countries), initialFirstName: config.initial_first_name, initialLastName: config.initial_last_name, showDiscountRibbon: config.show_discount_ribbon, installmentOptionsUrl: config.installment_options_url, locale: locale, debug: debug })
        : _jsx(_Fragment, {});
};
export default AmwalMagentoReactButton;
